import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=c543f578&scoped=true"
import script from "./BackArrow.vue?vue&type=script&lang=js"
export * from "./BackArrow.vue?vue&type=script&lang=js"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=c543f578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c543f578",
  null
  
)

export default component.exports